import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TrafficLightIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11 1.5C11 1.22386 10.7761 1 10.5 1H5.5C5.22386 1 5 1.22386 5 1.5V3H2.5C2.22386 3 2 3.22386 2 3.5V3.79289C2 3.9255 2.05268 4.05268 2.14645 4.14645L5 7V9H2.5C2.22386 9 2 9.22386 2 9.5V9.79289C2 9.9255 2.05268 10.0527 2.14645 10.1464L5 13V14.5C5 14.7761 5.22386 15 5.5 15H10.5C10.7761 15 11 14.7761 11 14.5V13L13.8536 10.1464C13.9473 10.0527 14 9.9255 14 9.79289V9.5C14 9.22386 13.7761 9 13.5 9H11V7L13.8536 4.14645C13.9473 4.05268 14 3.9255 14 3.79289V3.5C14 3.22386 13.7761 3 13.5 3H11V1.5ZM9.5 5C9.5 5.82843 8.82843 6.5 8 6.5C7.17157 6.5 6.5 5.82843 6.5 5C6.5 4.17157 7.17157 3.5 8 3.5C8.82843 3.5 9.5 4.17157 9.5 5ZM8 12.5C8.82843 12.5 9.5 11.8284 9.5 11C9.5 10.1716 8.82843 9.5 8 9.5C7.17157 9.5 6.5 10.1716 6.5 11C6.5 11.8284 7.17157 12.5 8 12.5Z"
			></path>
		</svg>
	),
)
